/*
 * JHYP Bundle & Save
 * Controller for the jhyp_bundle block (snippets/jhyp-bundle.liquid).
 * Pack tiers with live price math, slot list with auto-filled slot 1,
 * product picker modal with per-row variant matching, one-call add to cart
 * with hidden line item properties. Bundle discounts are handled entirely by
 * Shopify automatic discounts (2+ = 15%, 3+ = 20%) — the widget applies no code.
 */
(function () {
  'use strict';

  function initBundle(root) {
    if (root.dataset.jhypBundleReady) return;
    root.dataset.jhypBundleReady = '1';

    var blockId = root.getAttribute('data-block-id');
    var modal = document.querySelector('.jhyp-modal-ov[data-bundle-modal="' + blockId + '"]');
    if (!modal) return;
    if (modal.parentNode !== document.body) document.body.appendChild(modal);
    modal.removeAttribute('hidden');

    var currentName = root.getAttribute('data-current-name');
    var currentImg = root.getAttribute('data-current-img');
    var propertyPack = root.getAttribute('data-property-pack') || '_bundle_pack';
    var propertyId = root.getAttribute('data-property-id') || '_bundle_id';
    var afterAdd = root.getAttribute('data-after-add') || 'cart';

    function getCartType() {
      return (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.cartType) || (afterAdd === 'drawer' ? 'drawer' : 'page');
    }

    var optionNames = [];
    try { optionNames = JSON.parse(root.getAttribute('data-option-names') || '[]'); } catch (e) {}
    function matenFromTitle(title, names) {
      if (!title || title === 'Default Title') return '';
      var parts = String(title).split(' / ');
      if (!names || names.length !== parts.length) return '';
      return names.map(function (n, i) { return n + ': ' + parts[i]; }).join(' · ');
    }

    var pdpVariants = [];
    try { pdpVariants = JSON.parse(root.querySelector('[data-pdp-variants]').textContent || '[]'); } catch (e) {}

    var moneyFormat = (window.MinimogSettings && window.MinimogSettings.money_format) || null;
    function fmt(cents) {
      var value = (cents / 100).toFixed(2).replace('.', ',');
      return '€' + value;
    }

    function t(key, fallback) {
      var el = root.querySelector('.jhyp-bundle__i18n [data-i18n="' + key + '"]');
      return el && el.textContent ? el.textContent : fallback;
    }

    function xhrRequest(url, options) {
      options = options || {};
      return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open(options.method || 'GET', url, true);
        Object.keys(options.headers || {}).forEach(function (key) {
          xhr.setRequestHeader(key, options.headers[key]);
        });
        xhr.onload = function () {
          var text = xhr.responseText || '';
          var data = text;
          if (options.responseType === 'json') {
            try { data = text ? JSON.parse(text) : null; } catch (err) { reject(err); return; }
          }
          if (xhr.status >= 200 && xhr.status < 300) {
            resolve(data);
          } else {
            reject(new Error((data && (data.description || data.message)) || ('HTTP ' + xhr.status)));
          }
        };
        xhr.onerror = function () { reject(new Error('Network request failed')); };
        xhr.send(options.body || null);
      });
    }

    var activeSlot = null;
    var slot1IsAuto = true;

    function getCurrentVariant() {
      var params = new URLSearchParams(window.location.search);
      var fromUrl = params.get('variant');
      if (fromUrl) {
        var match = pdpVariants.find(function (v) { return String(v.id) === String(fromUrl); });
        if (match) return match;
      }
      var fallbackId = root.getAttribute('data-current-variant');
      var fb = pdpVariants.find(function (v) { return String(v.id) === String(fallbackId); });
      if (fb) return fb;
      return pdpVariants.find(function (v) { return v.available; }) || pdpVariants[0] || null;
    }

    function slotMarkup(slot, data) {
      if (data) {
        slot.setAttribute('data-variant', data.id);
        if (data.maten) slot.setAttribute('data-maten', data.maten); else slot.removeAttribute('data-maten');
        slot.setAttribute('data-price', data.price);
        slot.setAttribute('data-size', data.size || '');
        slot.innerHTML =
          '<span class="jhyp-slot__thumb">' + (data.img ? '<img src="' + data.img + '" alt="">' : '') + '</span>' +
          '<span class="jhyp-slot__info"><span class="jhyp-slot__name">' + data.name + '</span>' +
          '<span class="jhyp-slot__meta">' + (data.size && data.size !== 'Default Title' ? t('size', 'Maat') + ' ' + data.size + ' · ' : '') + fmt(data.price) + '</span></span>' +
          '<button class="jhyp-slot__choose" type="button">' + t('edit', 'Wijzig') + '</button>';
      } else {
        slot.removeAttribute('data-variant');
        slot.removeAttribute('data-price');
        slot.removeAttribute('data-maten');
        slot.innerHTML =
          '<span class="jhyp-slot__thumb jhyp-slot__thumb--empty"></span>' +
          '<span class="jhyp-slot__info"><span class="jhyp-slot__name jhyp-slot__name--placeholder">' + t('pick-item', 'Kies item') + ' ' + slot.getAttribute('data-slot-index') + '</span>' +
          '<span class="jhyp-slot__meta">' + t('slot', 'Slot') + ' ' + slot.getAttribute('data-slot-index') + '</span></span>' +
          '<button class="jhyp-slot__choose" type="button">' + t('choose', 'Kiezen') + '</button>';
      }
      slot.querySelector('.jhyp-slot__choose').addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        activeSlot = slot;
        openModal();
      });
    }

    function renderSlots() {
      var current = getCurrentVariant();
      root.querySelectorAll('.jhyp-pack__slots-inner').forEach(function (inner) {
        var count = parseInt(inner.getAttribute('data-slots'), 10);
        inner.innerHTML = '';
        for (var i = 1; i <= count; i++) {
          var slot = document.createElement('span');
          slot.className = 'jhyp-slot';
          slot.setAttribute('data-slot-index', i);
          if (i === 1 && current) {
            slot.setAttribute('data-auto', '1');
            slotMarkup(slot, { id: current.id, price: current.price, size: current.title, img: currentImg, name: currentName, maten: matenFromTitle(current.title, optionNames) });
          } else {
            slotMarkup(slot, null);
          }
          inner.appendChild(slot);
        }
      });
      updateCta();
    }

    function syncSlot1() {
      if (!slot1IsAuto) return;
      var current = getCurrentVariant();
      if (!current) return;
      root.querySelectorAll('.jhyp-pack .jhyp-slot[data-slot-index="1"][data-auto="1"]').forEach(function (slot) {
        slotMarkup(slot, { id: current.id, price: current.price, size: current.title, img: currentImg, name: currentName, maten: matenFromTitle(current.title, optionNames) });
        slot.setAttribute('data-auto', '1');
      });
      updateCta();
    }

    window.addEventListener('popstate', syncSlot1);
    ['pushState', 'replaceState'].forEach(function (method) {
      var original = history[method];
      history[method] = function () {
        var result = original.apply(history, arguments);
        setTimeout(syncSlot1, 40);
        return result;
      };
    });
    ['variant:change', 'variant:changed', 'variantchange', 'product:variant-change'].forEach(function (evt) {
      document.addEventListener(evt, function () { setTimeout(syncSlot1, 40); });
    });

    function selectedPack() {
      var checked = root.querySelector('.jhyp-pack input:checked');
      return checked ? checked.closest('.jhyp-pack') : null;
    }

    function basePrice() {
      var pack = selectedPack();
      if (pack) {
        var slot1 = pack.querySelector('.jhyp-slot[data-slot-index="1"][data-price]');
        if (slot1) return parseFloat(slot1.getAttribute('data-price'));
      }
      var avail = pdpVariants.find(function (v) { return v.available; }) || pdpVariants[0];
      return avail ? avail.price : 0;
    }

    function updateTierPrices() {
      var base = basePrice();
      root.querySelectorAll('.jhyp-pack').forEach(function (pack) {
        var count = parseInt(pack.getAttribute('data-count'), 10);
        var discount = parseInt(pack.getAttribute('data-discount'), 10) || 0;
        var filled = pack.querySelectorAll('.jhyp-slot[data-variant]');
        var subtotal = 0;
        for (var i = 0; i < count; i++) {
          subtotal += (i < filled.length) ? parseFloat(filled[i].getAttribute('data-price')) : base;
        }
        var after = subtotal * (1 - discount / 100);
        var now = pack.querySelector('[data-price-now]');
        var was = pack.querySelector('[data-price-was]');
        var save = pack.querySelector('[data-save]');
        if (now) now.textContent = fmt(after);
        if (was) was.textContent = discount > 0 ? fmt(subtotal) : '';
        if (save && discount > 0) {
          save.textContent = t('save-prefix', 'Bespaar') + ' ' + fmt(subtotal - after) + ' (' + discount + '% ' + t('save-suffix', 'korting') + ')';
        }
      });
    }

    function updateCta() {
      updateTierPrices();
      var pack = selectedPack();
      var cta = root.querySelector('.jhyp-bundle__cta');
      if (!pack || !cta) return;
      var count = parseInt(pack.getAttribute('data-count'), 10);
      var discount = parseInt(pack.getAttribute('data-discount'), 10) || 0;
      var filled = pack.querySelectorAll('.jhyp-slot[data-variant]');
      var prepick = cta.querySelector('.jhyp-bundle__cta-prepick');
      var ready = cta.querySelector('.jhyp-bundle__cta-ready');
      var loading = cta.querySelector('.jhyp-bundle__cta-loading');
      loading.hidden = true;

      if (filled.length < count) {
        cta.disabled = true;
        prepick.hidden = false;
        ready.hidden = true;
        var remaining = count - filled.length;
        prepick.textContent = t('cta-prefix', 'Kies nog') + ' ' + remaining + ' ' + (remaining === 1 ? t('label-singular', 'set') : t('label-plural', 'sets'));
        return;
      }
      var subtotal = 0;
      filled.forEach(function (s) { subtotal += parseFloat(s.getAttribute('data-price')); });
      var total = subtotal * (1 - discount / 100);
      cta.disabled = false;
      prepick.hidden = true;
      ready.hidden = false;
      ready.textContent = t('cta-add', 'Toevoegen aan winkelwagen') + ' · ' + fmt(total);
    }

    root.querySelectorAll('.jhyp-pack input[type="radio"]').forEach(function (radio) {
      radio.addEventListener('change', function () { if (radio.checked) updateCta(); });
    });

    // ---- modal -------------------------------------------------------------
    function openModal() { modal.classList.add('open'); document.body.style.overflow = 'hidden'; }
    function closeModal() { modal.classList.remove('open'); document.body.style.overflow = ''; activeSlot = null; }
    modal.querySelector('.jhyp-mod__close').addEventListener('click', function (e) { e.preventDefault(); closeModal(); });
    modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('open')) closeModal(); });

    modal.querySelectorAll('.jhyp-mod-row__options').forEach(function (group) {
      var row = group.closest('.jhyp-mod-row');
      var btn = row.querySelector('.jhyp-mod-row__choose');
      var rowVariants;
      try { rowVariants = JSON.parse(group.getAttribute('data-variants') || '[]'); } catch (e) { rowVariants = []; }

      function sync() {
        var selects = group.querySelectorAll('select[data-option-index]');
        var values = Array.prototype.map.call(selects, function (s) { return s.value; });
        var match = rowVariants.find(function (v) {
          if (!v.options || v.options.length !== values.length) return false;
          for (var i = 0; i < values.length; i++) if (String(v.options[i]) !== String(values[i])) return false;
          return true;
        });
        selects.forEach(function (sel) {
          var idx = parseInt(sel.getAttribute('data-option-index'), 10);
          Array.prototype.forEach.call(sel.options, function (opt) {
            var anyAvailable = rowVariants.some(function (v) {
              if (!v.available) return false;
              for (var i = 0; i < values.length; i++) {
                if (i === idx) { if (String(v.options[i]) !== String(opt.value)) return false; }
                else if (String(v.options[i]) !== String(values[i])) return false;
              }
              return true;
            });
            opt.disabled = !anyAvailable;
            opt.textContent = anyAvailable ? opt.value : opt.value + ' – ' + t('sold-out', 'Uitverkocht').toLowerCase();
          });
        });
        if (match) {
          btn.setAttribute('data-variant', match.id);
          btn.setAttribute('data-price', match.price);
          btn.setAttribute('data-size', match.title);
          btn.disabled = !match.available;
          btn.textContent = match.available ? t('modal-choose', 'Kies') : t('sold-out', 'Uitverkocht');
        } else {
          btn.disabled = true;
          btn.textContent = t('unavailable', 'Niet beschikbaar');
        }
      }

      var firstAvailable = rowVariants.find(function (v) { return v.available; });
      if (firstAvailable && firstAvailable.options) {
        group.querySelectorAll('select[data-option-index]').forEach(function (sel, i) {
          if (firstAvailable.options[i] != null) sel.value = firstAvailable.options[i];
        });
      }
      group.addEventListener('change', sync);
      sync();
    });

    modal.querySelectorAll('.jhyp-mod-row__choose').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (!activeSlot || btn.disabled) return;
        if (activeSlot.getAttribute('data-slot-index') === '1') { slot1IsAuto = false; activeSlot.removeAttribute('data-auto'); }
        var rowEl = btn.closest('.jhyp-mod-row');
        var rowMaten = [];
        if (rowEl) rowEl.querySelectorAll('.jhyp-mod-row__opt').forEach(function (opt) {
          var lbl = opt.querySelector('.jhyp-mod-row__opt-label');
          var sel = opt.querySelector('select');
          if (lbl && sel) rowMaten.push(lbl.textContent.trim() + ': ' + sel.value);
        });
        slotMarkup(activeSlot, {
          maten: rowMaten.join(' · '),
          id: btn.getAttribute('data-variant'),
          price: parseFloat(btn.getAttribute('data-price')),
          size: btn.getAttribute('data-size'),
          img: btn.getAttribute('data-img'),
          name: btn.getAttribute('data-name'),
        });
        closeModal();
        updateCta();
      });
    });

    // ---- add to cart ---------------------------------------------------------
    root.querySelector('.jhyp-bundle__cta').addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var pack = selectedPack();
      if (!pack) return;
      var count = parseInt(pack.getAttribute('data-count'), 10);
      var filled = pack.querySelectorAll('.jhyp-slot[data-variant]');
      if (filled.length < count) return;

      var items = [];
      filled.forEach(function (slot) {
        var properties = {};
        var maten = slot.getAttribute('data-maten');
        if (maten) properties['Maten'] = maten;
        properties[propertyPack] = pack.getAttribute('data-count');
        properties[propertyId] = blockId;
        items.push({ id: parseInt(slot.getAttribute('data-variant'), 10), quantity: 1, properties: properties });
      });

      var cta = root.querySelector('.jhyp-bundle__cta');
      var prepick = cta.querySelector('.jhyp-bundle__cta-prepick');
      var ready = cta.querySelector('.jhyp-bundle__cta-ready');
      var loading = cta.querySelector('.jhyp-bundle__cta-loading');
      cta.disabled = true; prepick.hidden = true; ready.hidden = true;
      loading.hidden = false; loading.textContent = t('cta-adding', 'Toevoegen') + '…';

      var cartType = getCartType();
      var shouldOpenCartUi = cartType === 'drawer' || cartType === 'popover';

      // Work out the cart drawer's REAL in-page section id and request exactly
      // that. The drawer lives in a section group, so its id is group-prefixed
      // (e.g. "sections--123__cart-drawer"), and the theme reads the rendered
      // HTML back under that exact key via extractSectionId(). Computing it from
      // the DOM the same way the theme does guarantees the keys match. Only
      // request the popup section when the global cart type is popup, otherwise
      // the bundle event can hydrate/open the wrong UI.
      var sectionsToBundle = cartType === 'popover' ? ['variant-added'] : [];
      if (cartType === 'drawer') sectionsToBundle.push('cart-drawer');
      var jbDrawerEl = document.querySelector('cart-drawer, #cart-drawer');
      var jbDrawerSection = jbDrawerEl && jbDrawerEl.closest('.shopify-section');
      var jbDrawerSectionId = '';
      if (cartType === 'drawer' && jbDrawerSection && jbDrawerSection.id) {
        jbDrawerSectionId = jbDrawerSection.id.replace('shopify-section-', '');
        sectionsToBundle.push(jbDrawerSectionId);
      }
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));
      sectionsToBundle = sectionsToBundle.filter(function (v, i) { return v && sectionsToBundle.indexOf(v) === i; });

      var routesRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
      var addUrl = routesRoot + 'cart/add.js';

      // Bundle discounts are applied automatically at checkout by Shopify
      // automatic discounts ("Bundel Korting" 2+ = 15%, 3+ = 20%), so the widget
      // never applies a discount code — it just adds the items. This keeps the
      // checkout session clean (no /discount/ navigation, no code/auto conflict).
      xhrRequest(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items, sections: sectionsToBundle, sections_url: window.location.pathname }),
        responseType: 'json',
      }).then(function (addResponse) {
        if (shouldOpenCartUi) {
          // Refresh the theme cart state after the multi-item add. The native
          // Impact drawer needs the rendered cart-drawer section attached to the
          // cart object before variant:add/cart:change are fired.
          return xhrRequest(routesRoot + 'cart.js', { headers: { 'Cache-Control': 'no-cache' }, responseType: 'json' }).then(function (cart) {
            cart.sections = addResponse.sections || {};
            if (jbDrawerSectionId && !cart.sections[jbDrawerSectionId]) {
              return xhrRequest(routesRoot + '?section_id=' + encodeURIComponent(jbDrawerSectionId)).then(function (sectionHtml) {
                cart.sections[jbDrawerSectionId] = sectionHtml;
                return cart;
              });
            }
            return cart;
          }).then(function (cart) {
            var addedItems = addResponse.items ? addResponse.items : [addResponse];
            document.documentElement.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: addedItems, cart: cart, cartType: cartType } }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
            cta.disabled = false; loading.hidden = true; ready.hidden = false;
          });
        }
        window.location.href = routesRoot + 'cart';
      }).catch(function (err) {
        console.error('[JHYP Bundle] add failed', err);
        cta.disabled = false; loading.hidden = true; ready.hidden = false;
        alert(err.message || 'Er ging iets mis. Probeer het opnieuw.');
      });
    });

    renderSlots();
  }

  function boot() {
    document.querySelectorAll('.jhyp-bundle').forEach(initBundle);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
